<label class="subHeading">RTO</label>
<mat-select class="rto" placeholder="All">
    <mat-option *ngFor="let stateObj of rtoList" [value]="stateObj.rto_id">
        {{stateObj.name}}
    </mat-option>
</mat-select>